var exports = {
  "kL": "xdbfd91f1--9e276e--container",
  "dx": "xdbfd91f1--9e276e--join-top",
  "dZ": "xdbfd91f1--9e276e--join-bottom",
  "x_": "xdbfd91f1--9e276e--fat_gallery_cover",
};

module.exports = exports;
